module.exports = __webpack_public_path__ + "media/images/icons/arrow_left-736d2368cfad911748f824433b0c34c7.svg";